import React, { useEffect, useState } from 'react'
import Header from '../../../component/Produzioni/Header'
import DashboardCard from '../../../component/Produzioni/DashboardCard';
import TableInputFeildTransport from '../../../component/Produzioni/TableInputFeildTransport';
import TrattamentiFrom from '../../../component/Produzioni/TrattamentiFrom';
import { resetFormSubmit, storeFormData } from '../../../features/produzioniFormData/produzioniFormDataSlice';
import produzioniFormAPI from '../../../services/produzioniFormApi';
import { useDispatch, useSelector } from 'react-redux';

const Trasportoeconferimento = ({ option, activeStep, setActiveStep }) => {
    const dispatch = useDispatch();
    const singleProduzioneID = useSelector((state) => state.produzioni.singleProduzioneId);
    const submitForm = useSelector((state) => state.produzioniForm.submitForm);

    const [tableData, setTableData] = useState([
        { company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id: singleProduzioneID, departure_date_and_time: null, arrival_date_and_time: null, stabili_id: "", transport_temp: "", peso: "", humidity: "" },
    ]);

    const [treatment, setTreatment] = useState([
        { company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id: singleProduzioneID, pro_treatment_id: "", tratt_date: null, pro_utilizzato: "", pro_qty: "", mod_di_applicazione: "", operatore_id: "", sicurezza: "" }
    ]);


    const data = {
        id: 1,
        title: "Trasporto e conferimento",
        description:
            "Monitora temperatura e tempi di trasporto per evitare fermentazioni indesiderate o deterioramento dell'uva.",
        buttonText: "Completa fase",
    };
    const temperatureCompliance = tableData.reduce((acc, item) => acc + Number(item.humidity),0)/tableData.length;
    const discardedGrapes = tableData.reduce((acc, item) => acc + Number(item.peso),0);

    const dummyData = {

        temperatureCompliance: "OK",
        totalCollected: temperatureCompliance + "°",
        discardedGrapes: discardedGrapes + " Kg",
        tasks: [
            "Trasporto dell'uva alla cantina",
            "Monitoraggio delle condizioni di trasporto",
            "Pesatura e accettazione in cantina",
        ],
    };

    const infoFields = [
        { label: "Conformità temperatura al trasporto", key: dummyData.temperatureCompliance, showIcon: true },
        { label: "Umidità ambiente", key: dummyData.totalCollected },
        { label: "Peso totale all’arrivo", key: dummyData.discardedGrapes },
    ];

    const fetchDataForUpdate = async () => {
        try {
          const payload = {
            company_id: localStorage.getItem('company_id'),
            step: activeStep,
            prod_id: singleProduzioneID,
          };
    
          const response = await produzioniFormAPI.getSingleStepFormData(payload);
          console.log(response, "response racolta")
          if (response?.data.data.transporto?.length) {
            const existingTable = response.data.data.transporto;
            setTableData(existingTable);
          }
          if (response?.data.data.production_step_treatment?.length) {
            const existingTreatment = response.data.data.production_step_treatment;
            setTreatment(existingTreatment);
          }
        } catch (error) {
          console.error("Error fetching single step form data:", error);
        }
      };
      
      useEffect(() => {
          fetchDataForUpdate();
      }, []);
    
    const onSubmit = async (tableData, treatment) => {
        const data = {
            step: activeStep,
            forms: {
                transporto: tableData,
                production_step_treatment: treatment
            }
        }
        console.log("Submitted data:", data);
        try {
              await produzioniFormAPI.updateStepFormData(singleProduzioneID, data);
            setActiveStep((prev) => prev + 1);
          } catch (error) {
            fetchDataForUpdate();
            console.error('Error submitting form data:', error);
          }
    };

    useEffect(() => {
        if (submitForm) {
            onSubmit(tableData, treatment);
            dispatch(resetFormSubmit());
        }
    }, [submitForm, dispatch]);

    return (
        <>
            <Header data={data} setActiveStep={setActiveStep} activeStep={activeStep} />
            <DashboardCard dummyData={dummyData} infoFields={infoFields} />
            <TableInputFeildTransport
                option={option}
                rows={tableData}
                setRows={setTableData}
                activeStep={activeStep}
            />
            <TrattamentiFrom
                option={option}
                rows={treatment}
                setRows={setTreatment}
                activeStep={activeStep}
            />
        </>
    )
}

export default Trasportoeconferimento